import React from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, GalleryField } from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import Modal from "components/Modal";
import { TextArea, Select } from "components/form";
import { useCore } from "store/core";
// components

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{ ...transformTranslateServerValues(item) }}
          onSubmit={async (values, { setSubmitting }) => {
            if (!values.parent_id) {
              delete values.parent_id;
            }
            await props.submit(transformTranslateFromValues(values), item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body py-1 gap-y-3">
                <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="verbose_name"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    placeholder="name"
                    label="عنوان سیستمی:"
                    name="name"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
